import {
    AfterViewInit,
    Component,
    Input,
    OnDestroy,
    OnInit,
} from "@angular/core";

import { Subscription } from "rxjs";
import { gameBallChangeLang } from "src/app/gameball";
import { EmbryoService } from "src/app/Services/Embryo.service";
import { TranslateService } from "@ngx-translate/core";
import { LoginUsersService } from "../../Services/login-users.service";
import { ReactivityService } from "../../Services/reactivity.service";
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { StaticPagesService } from "src/app/Services/static-pages.service";

@Component({
    selector: "embryo-LanguageDropDown",
    templateUrl: "./LanguageDropDown.component.html",
    styleUrls: ["./LanguageDropDown.component.scss"],
})
export class LanguageDropDownComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() selectedValue: any;
    @Input() lang: string = localStorage.getItem('lang') ? localStorage.getItem('lang') as string : "en";
    @Input() environmentVariables: any;
    currentLang = "en";
    isRtl: any;
    clickCange = true;
    langArray = [
        {
            name: "en",
            value: "en",
        },
        {
            name: "عربى",
            value: "ar",
        },
    ];
    isAuthUser: any;
    subscription: Subscription;
    firstTime: boolean = false;
    headerTextColor: any;
    showLangDropdown: boolean = false;
  
    constructor(
        public translate: TranslateService,
        public embryoService: EmbryoService,
        private loginService: LoginUsersService,
        private reactivityService: ReactivityService,
        private router: Router,
        private _location: Location,
        private confgServ: StaticPagesService
    ) {
        this.subscription = this.reactivityService.storeObserver$.subscribe(
            (data: any) => {
                if (data && data.loggedInUser) this.initLangSettings();
                window.scroll(0, window.pageYOffset);
            }
        );
        this.getInitilizingData();
    }

    ngOnInit() {
        this.initLangSettings();
    }

    ngAfterViewInit() {}

    getInitilizingData() {
        this.confgServ.getenvConfig().subscribe((res) => {
            this.headerTextColor = res.HEADER_TEXT_COLOR;
        });
    }

    ngOnDestroy() {
        if (this.subscription) this.subscription.unsubscribe();
    }

    public changeDirection(lang = this.lang) {
        let oldLang;
        if (lang == "en") oldLang = "/ar";
        else oldLang = "/en";
        let currentUrl = this.router.url.replace(oldLang, `/${lang}`);
        this._location.go(currentUrl);
        const body = document.querySelector("body");
        if (body && lang === "en") {
            body.id = "en";
            localStorage.setItem("lang", lang);
            this.isRtl = "ltr";
            this.embryoService.isDirectionRtl = false;
            this.lang = lang;
            this.embryoService.Emitlanguage(lang);
            this.translate.use(lang);
            gameBallChangeLang(lang);
        } 
        else if (body && lang !== "en") {
            body.id = "ar";
            localStorage.setItem("lang", lang);
            this.isRtl = "rtl";
            this.embryoService.isDirectionRtl = true;
            this.lang = lang;
            this.embryoService.Emitlanguage(lang);
            this.translate.use(lang);
            gameBallChangeLang(lang);
        }
        this.setUserLang(lang);
        this.checkMenuScroll();
    }

    checkMenuScroll() {
        setTimeout(() => {
            if (document.querySelector("#app-nav-list-menu")) {
                let menu = document.querySelector("#app-nav-list-menu");
                if (menu) {
                    let hasHorizontalScrollbar =
                        menu.scrollWidth > menu.clientWidth;
                    if (hasHorizontalScrollbar) {
                        this.embryoService.showScrollButton = true;
                    } else {
                        this.embryoService.showScrollButton = false;
                    }
                }
            } else if (document.querySelector("#app-nav-list-menu2")) {
                let menu = document.querySelector("#app-nav-list-menu2");
                if (menu) {
                    let hasHorizontalScrollbar =
                        menu.scrollWidth > menu.clientWidth;
                    if (hasHorizontalScrollbar) {
                        this.embryoService.showScrollButton = true;
                    } else {
                        this.embryoService.showScrollButton = false;
                    }
                }
            }
        }, 500);
    }

    initLangSettings() {
        const localLang = localStorage.getItem("lang");
        this.firstTime = true;
        this.isAuthUser = JSON.parse(
            <string>localStorage.getItem("auth_user_crocs")
        );
        this.lang =
            this.isAuthUser && this.isAuthUser.user_settings
                ? this.isAuthUser.user_settings.language
                : localLang;
        this.lang.toLowerCase() === "en"
            ? this.translate.setDefaultLang("en")
            : this.translate.setDefaultLang("ar");
        this.changeDirection(localLang as string);
    }

    setUserLang(lang = this.lang) {
        if (this.isAuthUser && !this.firstTime) {
            const data = { language: lang };
            this.loginService.setUserLanguage(data).subscribe((res: any) => {
                if (res.code === 200)
                    localStorage.setItem(
                        "auth_user_crocs",
                        JSON.stringify(res.data)
                    );
            });
        }
        this.firstTime = false;
    }
}
